import Forest from './photos/Forest_Edited_Caroussel.jpg';
import LightHouse from './photos/Light_House_Edited_Caroussel.jpg';
import Mary from './photos/Mary_Edited_Caroussel.jpg';
import Anonimo from './photos/Anonimo_Edited_Caroussel.jpg';
import travel1 from './photos/travel1.jpg';
import travel2 from './photos/travel2.jpg';
import travel3 from './photos/travel3.jpg';
import travel4 from './photos/travel4.jpg';
import travel5 from './photos/travel5.jpg';
import travel6 from './photos/travel6.jpg';
import travel7 from './photos/travel7.jpg';
import travel8 from './photos/travel8.jpg';
import travel9 from './photos/travel9.jpg';
import travel10 from './photos/travel10.jpg';
import travel11 from './photos/travel11.jpg';
import travel12 from './photos/travel12.jpg';
import travel13 from './photos/travel13.jpg';
import travel14 from './photos/travel14.jpg';
import travel15 from './photos/travel15.jpg';
import travel16 from './photos/travel16.jpg';
import travel17 from './photos/travel17.jpg';
import travel18 from './photos/travel18.jpg';
import travel19 from './photos/travel19.jpg';
import travel20 from './photos/travel20.jpg';
import travel21 from './photos/travel21.jpg';
import travel22 from './photos/travel22.jpg';
import foto1 from './photos/retrato_1.jpg';
import foto2 from './photos/retrato_2.jpg';
import foto3 from './photos/retrato_3.jpg';
import foto4 from './photos/retrato_4.jpg';
import foto5 from './photos/retrato_5.jpg';
import foto6 from './photos/retrato_6.jpg';
import foto7 from './photos/retrato_7.jpg';
import foto8 from './photos/retrato_8.jpg';
import foto9 from './photos/retrato_9.jpg';
import landscape0 from './photos/landscape0.jpg';
import landscape1 from './photos/landscape1.jpg';
import landscape2 from './photos/landscape2.jpg';
import landscape3 from './photos/landscape3.jpg';
import landscape4 from './photos/landscape4.jpg';
import landscape5 from './photos/landscape5.jpg';
import landscape6 from './photos/landscape6.jpg';
import landscape7 from './photos/landscape7.jpg';
import landscape8 from './photos/landscape8.jpg';
import landscape10 from './photos/landscape10.jpg';
import landscape11 from './photos/landscape11.jpg';
import landscape12 from './photos/landscape12.jpg';







export const photos = [
    {
        src: Forest,
        width: 4,
        height: 6,
    },
    {
        src: LightHouse,
        width: 4,
        height: 6,
    },
    {
        src: Mary,
        width: 4,
        height: 6,
    },
    {
        src: Anonimo,
        width: 4,
        height: 6,
    },
    {
        src: travel1,
        width: 4,
        height: 6,
      },
      {
        src: travel2,
        width: 4,
        height: 6,
      },
      {
        src: travel3,
        width: 4,
        height: 6,
      },
      {
        src: travel4,
        width: 6,
        height: 4,
      },
      {
        src: travel5,
        width: 6,
        height: 4,
      },
    
      {
        src: travel6,
        width: 6,
        height: 4,
      },
    
      {
        src: travel7,
        width: 4,
        height: 6,
      },
      {
        src: travel8,
        width: 4,
        height: 6,
      },
      {
        src: travel9,
        width: 4,
        height: 6,
      },
      {
        src: travel10,
        width: 6,
        height: 4,
      },
      {
        src: travel11,
        width: 6,
        height: 4,
      },
    
      {
        src: travel12,
        width: 6,
        height: 4,
      },
    
      {
        src: travel13,
        width: 4,
        height: 6,
      },
      {
        src: travel14,
        width: 4,
        height: 6,
      },
      {
        src: travel15,
        width: 4,
        height: 6,
      },
      {
        src: travel16,
        width: 6,
        height: 4,
      },
      {
        src: travel17,
        width: 6,
        height: 4,
      },
      {
        src: foto8,
        width: 4,
        height: 6,
      },
      {
        src: foto2,
        width: 4,
        height: 6,
      },
      {
        src: foto1,
        width: 4,
        height: 6,
      },
      {
        src: foto7,
        width: 4,
        height: 6,
      },
      {
        src: foto3,
        width: 4,
        height: 6,
      },
      {
        src: foto6,
        width: 4,
        height: 6,
      },
      {
        src: foto5,
        width: 2.2,
        height: 3,
      },
      {
        src: foto4,
        width: 6,
        height: 4,
      },
      {
        src: foto9,
        width: 6,
        height: 4,
      },
    
      {
        src: travel18,
        width: 6,
        height: 4,
      },
    
      {
        src: travel19,
        width: 4,
        height: 6,
      },
      {
        src: travel20,
        width: 4,
        height: 6,
      },
      {
        src: travel21,
        width: 4,
        height: 6,
      },
      {
        src: travel22,
        width: 6,
        height: 4,
      },
      {
        src: landscape0,
        width: 6,
        height: 4,
      },
      {
        src: landscape1,
        width: 6,
        height: 4,
      },
      {
        src: landscape2,
        width: 6,
        height: 4,
      },
      {
        src: landscape3,
        width: 6,
        height: 4,
      },
      {
        src: landscape4,
        width: 6,
        height: 4,
      },
      {
        src: landscape5,
        width: 6,
        height: 4,
      },
      {
        src: landscape6,
        width: 6,
        height: 4,
      },
      {
        src: landscape7,
        width: 6,
        height: 4,
      },
      {
        src: landscape8,
        width: 6,
        height: 4,
      },
      {
        src: landscape10,
        width: 4,
        height: 6,
      },
      {
        src: landscape11,
        width: 4,
        height: 6,
      },
      {
        src: landscape12,
        width: 4,
        height: 6,
      },
];